import { useCallback } from 'react';
import { DndContext, MouseSensor, TouchSensor, useSensor } from '@dnd-kit/core';
import { restrictToParentElement, restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext } from '@dnd-kit/sortable';
import { useAtomValue } from 'jotai';
import { cn } from '@/utils';
import { MAX_QUIZ_COUNT } from '../../constant';
import { useBuildFormContext } from '../../form/schema';
import { editingQuizIdAtom } from '../focus/editModeAtom';
import { focusField } from '../focus/focusUtils';
import { useQuizList } from '../useQuizList';
import { QuizShuffleButton } from './QuizShuffleButton';
import { QuizSliderHeader } from './QuizSliderHeader';
import { QuizSliderItem } from './QuizSliderItem';
export const QuizSliderSidebar = () => {
  const {
    quizList,
    handleDragEnd,
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    control
  } = useBuildFormContext();
  const editingId = useAtomValue(editingQuizIdAtom);
  const handleQuizClick = useCallback((index: number) => {
    focusField(`quizList.${index}.question`, {
      scroll: true,
      delay: 200
    });
  }, []);
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: 10
    }
  });
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 100,
      tolerance: 10
    }
  });
  return <DndContext autoScroll={false} modifiers={[restrictToVerticalAxis, restrictToParentElement]} onDragEnd={handleDragEnd} sensors={[mouseSensor, touchSensor]} data-sentry-element="DndContext" data-sentry-component="QuizSliderSidebar" data-sentry-source-file="QuizSliderSidebar.tsx">
      <SortableContext items={quizList.map(quiz => quiz.id)} data-sentry-element="SortableContext" data-sentry-source-file="QuizSliderSidebar.tsx">
        <div className={cn('fixed z-20 left-0 top-[64px] hidden h-[calc(100vh-60px)] w-[260px] flex-col border-r border-alternative transition-transform duration-300 bg-neutral', 'min-[1170px]:flex min-[1170px]:flex-col')}>
          {/* Header */}
          <QuizSliderHeader currentCount={quizList.length} maxCount={MAX_QUIZ_COUNT} data-sentry-element="QuizSliderHeader" data-sentry-source-file="QuizSliderSidebar.tsx" />

          {/* Question List */}
          <div className="min-h-0 flex-1 overflow-y-auto px-md py-4xs">
            <div className="flex flex-col gap-xs">
              {quizList.map((quiz, index) => <QuizSliderItem key={quiz.id} id={quiz.id} index={index} isEditMode={editingId === quiz.id} control={control} onClick={() => handleQuizClick(index)} onCopy={() => handleCopy(index)} onDelete={handleDelete} />)}
            </div>
          </div>
          <div className="w-full px-md pb-lg pt-md">
            <QuizShuffleButton data-sentry-element="QuizShuffleButton" data-sentry-source-file="QuizSliderSidebar.tsx" />
          </div>
        </div>
      </SortableContext>
    </DndContext>;
};
QuizSliderSidebar.displayName = 'QuizSliderSidebar';